// TODO: Need to add real component here. Check with Aman on this (Redundant at the moment)

import React from 'react'

const CallbackWidgetForm = () => (
  <div>This is the CallbackWidgetForm. Looks like a redundant component. Need to confirm</div>
)

export default CallbackWidgetForm
